import StyledSvg from './styles';

interface SvgProps {
  src?: string;
  alt?: string;
  width?: string;
  height?: string;
  minHeight?: string;
  maxHeight?: string;
  minWidth?: string;
  maxWidth?: string;
  display?: string;
  flex?: string;
  m?: string;
  p?: string;
}

const Svg = ({
  src,
  alt,
  width,
  height,
  minHeight,
  maxHeight,
  minWidth,
  maxWidth,
  display,
  flex,
  m,
  p,
}: SvgProps) => (
  <StyledSvg
    src={src}
    alt={alt}
    width={width}
    height={height}
    minHeight={minHeight}
    maxHeight={maxHeight}
    minWidth={minWidth}
    maxWidth={maxWidth}
    display={display}
    flex={flex}
    m={m}
    p={p}
  />
);

export default Svg;
